export default "__VITE_ASSET__ClwTx7IB__"